export default {"src":"/_next/static/media/43-icon.105fe5f4.svg","height":37,"width":46,"blurWidth":0,"blurHeight":0};